export default "__VITE_ASSET__85001b64__"